import { getBaseUrl, request } from 'src/helper/api';

export const getLuMiConversation = (
  serviceRequestId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/actions/lumi-intake-transcript`,
      contentType: 'json',
      token,
      signal,
    },
    'lumi-conversation/getLuMiConversation',
  );
